export const Config = Symbol('Config');
export type Config = {
  APP_ENV: string;
};
